<p translate="parameters/quick_replies/details/api_connector/description"></p>
